module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": _vm.layout,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-04289532!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/widghtPagination.vue
// module id = 438
// module chunks = 11